import { render, staticRenderFns } from "./ResourceSeatMap.vue?vue&type=template&id=838bb5d0&scoped=true&"
import script from "./ResourceSeatMap.vue?vue&type=script&lang=js&"
export * from "./ResourceSeatMap.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSeatMap.vue?vue&type=style&index=0&id=838bb5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838bb5d0",
  null
  
)

export default component.exports